<template>
  <div
    class="project-structure-shape"
    >
    <StandardDeleteButton
      class="project-structure-shape-delete"
      v-if="is_edit_mode"
      :zoom="0.8"
      @clickDelete="$emit('clickDelete')"
      />
    <div class="project-structure-shape-name">{{name}}</div>
  </div>
</template>
<script>
  import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
  export default {
    props: ['name', 'is_edit_mode'],
    components: {
      StandardDeleteButton,
    },
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-shape {
    display: flex;
    align-items: center;
  }
  .project-structure-shape:hover .project-structure-shape-delete {
    display: flex
  }
  .project-structure-shape-delete {
    display: none;
    position: absolute;
    overflow: visible;
  }
  .project-structure-shape-name {
    margin-left: 24px;
  }

</style>
